module.exports = __webpack_public_path__ + "img/upcoming-fixtures-2.2926ba36.svg";